/**
 * 常用正则表达式
 */

// 验证手机号和座机号
export const phoneRegExp = /^1\d{10}$/g;

// 身份证
export const idRegExp = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;

// 银行卡号
export const bankCardRegRxp = /^([1-9]{1})(\d{11}|\d{15}|\d{16}|\d{17}|\d{18})$/;

// 银行网点联行号
export const bankBranchNumber = /^\d{12}$/;

// 验证邮箱
export const emailRegExp = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;

// 验证QQ
export const qqRegExp = /^[1-9]\d{4,9}$/;

// 验证微信号
export const wxRegExp = /^[a-zA-Z]{1}[-_a-zA-Z0-9]{5,19}$/;
